import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import {USAreaCodes} from '../Constants';
import './ProposalUnlockModal.scss';

export default class ProposalUnlockModal extends Component {
    static get propTypes() {
        return {
            userId: PropTypes.number,
            requestId: PropTypes.number,
            responseId: PropTypes.number,
            isBuyer: PropTypes.bool,
            agentName: PropTypes.string,
            agentPhotoUrl: PropTypes.string,
            agentPhone: PropTypes.string,
            contact: PropTypes.bool,
            variant: PropTypes.string,
            isNotUS: PropTypes.bool,
            forceConfirmation: PropTypes.bool,
            onFinish: PropTypes.func
        };
    }

    state = {
        clientPhone: '',
        error: '',
        isLoading: false,
        contentToRender: 'phoneInput'
    };

    denormalizePhone = val => {
        const numbersOnly = val.replace(/[^0-9]/g, '');

        if (!this.props.isNotUS) {
            if (numbersOnly.length == 3) {
                this.setState({error: !USAreaCodes.includes(numbersOnly)});
            }
            if (!numbersOnly) {
                return '';
            }
            if (numbersOnly.length <= 3) {
                return '(' + numbersOnly;
            }
            return (
                '(' +
                numbersOnly.substr(0, 3) +
                (numbersOnly.length > 2 ? ')' : '') +
                (numbersOnly.length > 3 ? ' ' + numbersOnly.substr(3, 3) : '') +
                (numbersOnly.length > 6 ? '-' + numbersOnly.substr(6, 7) : '')
            );
        }
        return numbersOnly;
    };

    handleUnlockClick = () => {
        const numbersOnly = this.state.clientPhone.replace(/[^0-9]/g, '');
        if (numbersOnly.length < 10 || this.state.error) {
            return this.setState({error: true});
        }

        trackEvent('Proposal', 'incompleteSubmittedPhone', 'incompleteSubmittedPhone');
        if (this.props.contact || this.props.forceConfirmation) {
            this.setState({error: false, isLoading: true});

            $.post('add-user-phone-json', {
                phone: numbersOnly,
                userId: this.props.userId,
                requestId: this.props.requestId,
                buyer: this.props.isBuyer,
                forceConfirmation: this.props.forceConfirmation || false,
            }).then(data => {
                if (checkAjax(data)) {
                    this.props.onFinish && this.props.onFinish(numbersOnly);
                }
            }).fail(() => {
                defaultAjaxError();
            }).always(() => {
                this.setState({isLoading: false});
            });
        } else {
            this.props.onFinish && this.props.onFinish(numbersOnly);
        }
    };

    renderPhoneInput = () => {
        const {agentName, agentPhotoUrl, contact, variant} = this.props;
        const {isLoading, clientPhone, error} = this.state;

        return (
            <div className="modal-content">
                <div className="modal-header">
                    {!!agentPhotoUrl ? (
                        <img src={agentPhotoUrl} className="agent-photo" onError={event => replaceImageOnError(event.target, 'img/profile-icon-l.jpg')}/>
                    ) : (
                        <img className="lock-icon" src={`${global.imageBaseUrl}proposal/locked.svg`}/>
                    )}
                    <div className="modal-title">
                        {(contact || variant == 'autoPopup')
                            ? 'What’s your phone number?'
                            : 'Get full access to your proposals'
                        }
                    </div>
                </div>
                <div className="modal-body">
                    {variant == 'autoPopup' ? (
                        `Confirm your request by entering a valid phone number`
                    ) : (variant == 'call' || (!variant && agentName)) ? (
                        `Please enter a phone number ${getFirstName(agentName)} can reach you at.`
                    ) : (variant == 'message') ? (
                        `Please enter a phone number ${getFirstName(agentName)} can text you back.`
                    ) : (
                        `Finish signing up by entering a valid phone number.`
                    )}
                    <div className="phone-input-wrapper">
                        <i className="icon-contact-phone-outline"/>
                        <input
                            className="phone-input"
                            type="tel"
                            placeholder="(000) 000-0000"
                            value={clientPhone}
                            onInput={({target: {value}}) =>
                                this.setState({
                                    clientPhone: this.denormalizePhone(value)
                                })
                            }
                            maxLength={14}
                        />
                        {error && <div className="error">Please enter a valid 10-digit phone number.</div>}
                    </div>
                </div>
                <div className="modal-footer text-center">
                    <button onClick={this.handleUnlockClick} className="btn btn-default btn-blue">
                        Get Full Access
                    </button>
                </div>
                {isLoading && (
                    <div className="loadingSpinner" style="display: block; margin: 0">
                        <img src={global.imageBaseUrl + 'spinner.gif'} />
                    </div>
                )}
            </div>
        );
    };

    render() {
        return (
            <div className="modal nu-modal proposal-unlock-modal fade in" role="dialog">
                <div className="modal-dialog">{this.renderPhoneInput()}</div>
            </div>
        );
    }
}
